import { faFileExcel, faFileWord, faFilePdf, faFilePowerpoint, faFileImage, faFileAlt, faFileVideo, faFileCode, faFileArchive} from "@fortawesome/free-regular-svg-icons";
import { faBook, faLaptop, faDesktop, faTabletAlt, faServer, faCogs } from "@fortawesome/free-solid-svg-icons";
import { faApple, faAndroid} from "@fortawesome/free-brands-svg-icons";

export const getFileTypeIcon = (type) => {
    if (type){
        switch (type.toLowerCase()) {
            case "ppt":
            case "pptx":
                return faFilePowerpoint;
            case "doc": 
            case "docx":
                return faFileWord;
            case "xls":
            case "xlsx":
                return faFileExcel;    
            case "pdf":
                return faFilePdf;
            case "png":
            case "jpg":
            case "gif":
            case "tif":    
                return faFileImage;
            case "mp4":
            case "mov":    
                return faFileVideo;
            case "js":
                return faFileCode;
            case "zip":
            case "tar":
            case "rar":       
                return faFileArchive       
            default:
                return faFileAlt;
        }
    }

    return faFileAlt;
}

export const getIcon = (type) => {
    if (type){
        switch (type.toLowerCase()) {
            case "book":
                return faBook;
            case "laptop":
                return faLaptop;
            case "desktop":
                return faDesktop;
            case "android":
                return faAndroid;
            case "apple":
                return faApple;
            case "server":
                return faServer;
            case "cogs":
                return faCogs;
            case "tablet-alt":
                return faTabletAlt;
            default: 
                return faBook;                           
        }
    }
    return faBook;
}
